import { withKey, withoutKey } from 'piral-core';
export function createState(ctx, id, data) {
    ctx.dispatch((state) => ({
        ...state,
        containers: withKey(state.containers, id, data),
    }));
}
export function destroyState(ctx, id) {
    ctx.dispatch((state) => ({
        ...state,
        containers: withoutKey(state.containers, id),
    }));
}
export function replaceState(ctx, id, dispatch) {
    ctx.dispatch((state) => {
        const oldState = state.containers[id];
        const newState = dispatch(oldState);
        return {
            ...state,
            containers: withKey(state.containers, id, {
                ...oldState,
                ...newState,
            }),
        };
    });
}
//# sourceMappingURL=actions.js.map